import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { DashboardProvidersExternalComponent } from './dashboard-providers-external.component';
import { ProvDashboardComponent } from './prov-dashboard/prov-dashboard.component';

const routes: Routes = [
  {
    path: 'pages',
    component: T2TemplateBasicComponent,
    children: [
      {
        path: 'providers-dashboard-external',
        component: DashboardProvidersExternalComponent,
        data: { title: 'Dashboard'}
      }
    ]
  },
  {
    path: 'pages/prov-dashboard',
    component: ProvDashboardComponent,
    data: { title: 'Provider Dashboard'}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class DashboardProvidersRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers-external/dashboard-providers-external-routing.module.ts